var multiSelectDropdown = {};

multiSelectDropdown.data = {};
multiSelectDropdown.data.onChange = "spOnChange";

multiSelectDropdown.class = {};
multiSelectDropdown.class.parent = null;
multiSelectDropdown.class.number = null;

multiSelectDropdown.OnChange = function()
{
    var onChange = $($(this)[0].element).data(multiSelectDropdown.data.onChange);
    multiSelectDropdown.updateDropDownTreeNumber($(this)[0].element);
    if (typeof onChange !== 'undefined') {
        onChange(this);
    }
};

multiSelectDropdown.updateDropDownTreeNumber = function(element) {
    var number = $(element).data("kendoDropDownTree").value().length;
    var parent = $(element).closest('.' + multiSelectDropdown.class.parent);
    var numbers = parent.find('.' + multiSelectDropdown.class.number);

    numbers.text(number);
};

multiSelectDropdown.InitControl = function(name, onChange) {
    var elem = $("#" + name);
    multiSelectDropdown.InitControlElement(elem, onChange);
};

multiSelectDropdown.InitControlElement = function(elem, onChange) {
    var dropdownTree = elem.data("kendoDropDownTree");
    if (dropdownTree) {
        dropdownTree.bind("change", multiSelectDropdown.OnChange);
        elem.data(multiSelectDropdown.data.onChange, onChange);
        multiSelectDropdown.updateDropDownTreeNumber(elem);
    }
};

multiSelectDropdown.getSelectedItems = function (name) {
    return multiSelectDropdown.getSelectedItemsElement($("#" + name));
}

multiSelectDropdown.getSelectedItemsElement = function (element) {
    var checkedNodes = [];
    var dropdowntree = $(element).data("kendoDropDownTree");
    if (dropdowntree) {
        var nodes = dropdowntree.dataSource.view();
        for (var i = 0; i < nodes.length; i++) {
            if (nodes[i].checked) {
                checkedNodes.push(nodes[i].id);
            }
        }
    }
    return checkedNodes;
}
